import { makeUseAxios } from 'axios-hooks';

import { API } from 'src/app/services/axios';
import type { IEnumReference } from 'src/types/reference/IEnumReference';
import type { IProductReference } from 'src/types/reference/IProductReference';
import type { IProductSpecificationReference } from 'src/types/reference/IProductSpecificationReference';

const useAxiosApi = makeUseAxios({
  axios: API,
});

const BASE_PATH = '/referenceData';

export const referenceApi = {
  useGetProductReferencesQuery: () =>
    useAxiosApi<IProductReference[]>({
      url: `${BASE_PATH}/prods`,
      method: 'GET',
    }),

  useGetProductSpecificationReferencesQuery: () =>
    useAxiosApi<IProductSpecificationReference[]>({
      url: `${BASE_PATH}/specs`,
      method: 'GET',
    }),

  useGetEnumReferencesQuery: () =>
    useAxiosApi<IEnumReference[]>({
      url: `${BASE_PATH}/enums`,
      method: 'GET',
    }),
};
